import { Slider, Steps, StepsProps } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';

import ButtonArrow from '@src/Components/Atoms/ButtonArrow/ButtonArrow';
import Points from '@src/Components/Atoms/Points/Points';

import { useStores } from '@src/Common/Hooks/useStores';
import LoadingTimeline from '@src/Components/Atoms/LoadingTimeline/LoadingTimeline';
import styles from './TimeLine.module.scss';
import { TimeLineProps } from './TimeLine.type';
import { useTimeLine } from './useTimeLine';

const TimeLine: React.FC<TimeLineProps> = observer(
  ({ starYear, endYear, dataItems, isDetectedAction, onActiveTimeline }) => {
    const {
      stepsRef,
      allItems,
      yearRange,
      inputValue,
      inputMonth,
      handleChange,
      handleClickIcon,
      handleMythicEvent,
      handleAfterChange
    } = useTimeLine({
      starYear,
      endYear,
      dataItems,
      isDetectedAction,
      onActiveTimeline
    });

    const { DUMEventStore } = useStores();

    const viewCustomDot: StepsProps['progressDot'] = (_, { index, status }) => {
      const isMythicEvent = allItems[index].isMythicEvent;
      return (
        <div className={`dot`} onClick={() => handleChange(index + 1)}>
          <Points
            size={isMythicEvent ? 'lg' : 'md'}
            type={isMythicEvent ? 'img' : 'Default'}
            isActive={status === 'process'}
          />
        </div>
      );
    };

    return (
      <div data-testid={`time-line`}>
        {DUMEventStore.DUMEventDatas.timelineStatus.isLoading ? (
          <LoadingTimeline />
        ) : null}
        <section className={styles['step-item']}>
          <div ref={stepsRef}>
            <Steps
              current={inputMonth}
              progressDot={viewCustomDot}
              responsive={false}
              items={allItems}
            />
          </div>
        </section>
        <section className={styles['content-slider']}>
          <div className={styles['content-slider-btn']}>
            <ButtonArrow
              isDisabled={inputValue <= 1}
              onClick={() => handleMythicEvent('earlier')}
              type="double"
              rotation="left"
            />
            <ButtonArrow
              isDisabled={inputValue <= 1}
              onClick={() => handleClickIcon('prev')}
              type="default"
              rotation="left"
            />
            <span
              className={`${styles['left-year']}`}
              onClick={() => handleClickIcon('firstItem')}
            >
              {yearRange[0]}
            </span>
          </div>
          <div className={styles['timeline__slider']}>
            <Slider
              tooltip={{ open: false }}
              min={1}
              max={allItems.length}
              onChange={(e) => handleChange(e)}
              value={typeof inputValue === 'number' ? inputValue : 0}
              trackStyle={{
                backgroundColor: '#C4964D'
              }}
              railStyle={{
                backgroundColor: '#78531B',
                opacity: 0.75
              }}
              onAfterChange={(e) => handleAfterChange(e)}
            />
          </div>
          <div className={styles['content-slider-btn']}>
            <span
              className={`${styles['right-year']} `}
              onClick={() => handleClickIcon('lastItem')}
            >
              {yearRange[1]}
            </span>
            <ButtonArrow
              isDisabled={inputValue === allItems.length}
              onClick={() => handleClickIcon('next')}
              type="default"
              rotation="right"
            />
            <ButtonArrow
              isDisabled={inputValue === allItems.length}
              onClick={() => handleMythicEvent('latest')}
              type="double"
              rotation="right"
            />
          </div>
        </section>
      </div>
    );
  }
);

export default TimeLine;
